
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 공지사항 {{ $route.query.notice_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.notice_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='notice_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'notice_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.noticeTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.noticeTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='notice_top_status'>상단 공지<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="notice_top_status"
                v-model="formData.noticeTopStatus"
              >
                <option value='0'>미공지</option>
                <option value='1'>공지</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='notice_write'>작성자<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'notice_write'
                maxLength="10"
                placeholder = "작성자를 입력해 주세요.(10자 이내)"
                v-model="formData.noticeWrite"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.noticeWriteError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='notice_views'>조회수</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'notice_views'
                readonly
                v-model="formData.noticeViews"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='notice_status'>노출 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="notice_status"
                v-model="formData.noticeStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='notice_editor'>내용</label>
              <custom-textarea
                v-model="formData.noticeEditor"
                :id="'notice_editor'"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import {
  get_notice_one,
  insert_notice,
  update_notice,
  get_session_admin

} from '../../ETC/Axios.vue'

export default {
  name: 'AdminNoticeManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        noticeTitle: '',
        noticeTopStatus: '0',
        noticeWrite: '',
        noticeViews: '0',
        noticeStatus: 1,
        noticeEditor: ''
      }),
      errorData: ref({
        noticeTitleError: '',
        noticeWriteError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      let continue_add = true
      if (this.formData.noticeTitle === '') {
        this.errorData.noticeTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.noticeTitleError = ''
      }
      if (this.formData.noticeWrite === '') {
        this.errorData.noticeWriteError = '작성자를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.noticeWriteError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.notice_ID === undefined) {
          insert_notice(
            this.formData.noticeTitle,
            this.formData.noticeTopStatus,
            this.formData.noticeWrite,
            this.formData.noticeEditor,
            this.formData.noticeStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminNoticeManagement'
          })
        } else {
          update_notice(
            this.$route.query.notice_ID,
            this.formData.noticeTitle,
            this.formData.noticeTopStatus,
            this.formData.noticeWrite,
            this.formData.noticeEditor,
            this.formData.noticeStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminNoticeManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.notice_ID !== undefined) {
      get_notice_one(this.$route.query.notice_ID).then((result) => {
        this.formData.noticeTitle = result.notice[0].notice_title
        this.formData.noticeTopStatus = result.notice[0].notice_top_status
        this.formData.noticeWrite = result.notice[0].notice_write
        this.formData.noticeViews = result.notice[0].notice_views
        this.formData.noticeStatus = result.notice[0].notice_status
        this.formData.noticeEditor = result.notice[0].notice_editor
      })
    } else {
      get_session_admin().then(result => {
        if (result === '') {
          alert('로그인 유지시간이 만료되었습니다.')
          window.location.href = '/AdminLogin'
        } else {
          this.formData.noticeWrite = result.admin_name
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminNoticeManagementAdd.vue